"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Box_1 = require("@mui/material/Box");
var Typography_1 = require("@mui/material/Typography");
var Paper_1 = require("@mui/material/Paper");
var Grid_1 = require("@mui/material/Grid");
var material_1 = require("@mui/material");
require("./fe_audit_details.scss");
var approvals_helper_1 = require("../../super_admin/approval_management/apprvals/approvals_helper");
var fe_details_utils_1 = require("./fe_details_utils");
var moment = require("moment");
var formatSectionName = function (key) {
    return key
        .split("_")
        .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
        .join(" ");
};
var formatValue = function (value, type) {
    if (value === null || value === undefined)
        return React.createElement("span", { className: "null-dash" }, "\u2014");
    if (typeof value === "boolean")
        return value ? "Yes" : "No";
    return String(value);
};
var formatDate = function (date) { return moment.utc(date).local().format("DD-MM-YYYY, HH:mm"); };
function ApprovalsDisplay(_a) {
    var _this = this;
    var responseData = _a.responseData, previousData = _a.previousData, feName = _a.feName, feId = _a.feId;
    var current = responseData;
    var previous = previousData;
    var _b = React.useState({}), currentDocuments = _b[0], setCurrentDocuments = _b[1];
    var _c = React.useState({}), previousDocuments = _c[0], setPreviousDocuments = _c[1];
    var sections = Object.keys(approvals_helper_1.feDetailLabels).filter(function (section) { return responseData[section] && typeof responseData[section] === "object"; });
    var loadDocsForData = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var docs, _i, _a, sectionKey, section, _loop_1, _b, _c, fieldKey;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    docs = {};
                    _i = 0, _a = Object.keys(approvals_helper_1.feDetailLabels);
                    _d.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3, 6];
                    sectionKey = _a[_i];
                    section = data === null || data === void 0 ? void 0 : data[sectionKey];
                    if (!section)
                        return [3, 5];
                    _loop_1 = function (fieldKey) {
                        var isDocument, _e, _f;
                        return __generator(this, function (_g) {
                            switch (_g.label) {
                                case 0:
                                    isDocument = ["doc", "document", "photo"].some(function (word) {
                                        return fieldKey.includes(word);
                                    });
                                    if (!(isDocument && section[fieldKey])) return [3, 2];
                                    _e = docs;
                                    _f = fieldKey;
                                    return [4, (0, fe_details_utils_1.fetchSignedUrl)(section[fieldKey])];
                                case 1:
                                    _e[_f] = _g.sent();
                                    _g.label = 2;
                                case 2: return [2];
                            }
                        });
                    };
                    _b = 0, _c = Object.keys(section);
                    _d.label = 2;
                case 2:
                    if (!(_b < _c.length)) return [3, 5];
                    fieldKey = _c[_b];
                    return [5, _loop_1(fieldKey)];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _b++;
                    return [3, 2];
                case 5:
                    _i++;
                    return [3, 1];
                case 6: return [2, docs];
            }
        });
    }); };
    React.useEffect(function () {
        loadDocsForData(responseData).then(setCurrentDocuments);
    }, [responseData]);
    React.useEffect(function () {
        if (previousData) {
            loadDocsForData(previousData).then(setPreviousDocuments);
        }
    }, [previousData]);
    return (React.createElement(Box_1.default, { className: "approvals-root" },
        React.createElement(Box_1.default, { className: "approvals-wrapper" },
            React.createElement(Typography_1.default, { className: "fe-audit-modal__header-title" }, "FE Audit History"),
            React.createElement(Box_1.default, { className: "fe-audit-modal__info-strip" },
                React.createElement(Box_1.default, { className: "info-item" },
                    React.createElement(Typography_1.default, { className: "info-item__label" }, "FE ID"),
                    React.createElement(Typography_1.default, { className: "info-item__value" }, feId)),
                React.createElement(material_1.Divider, { orientation: "vertical", flexItem: true, className: "info-divider" }),
                React.createElement(Box_1.default, { className: "info-item" },
                    React.createElement(Typography_1.default, { className: "info-item__label" }, "Name"),
                    React.createElement(Typography_1.default, { className: "info-item__value info-item__value--name" }, feName))),
            React.createElement(Paper_1.default, { className: "approvals-card", elevation: 0 },
                React.createElement(Box_1.default, { className: "card-header" },
                    React.createElement(Box_1.default, null,
                        React.createElement(Typography_1.default, { className: "card-header__label" }, "Created By"),
                        React.createElement(Typography_1.default, { className: "card-header__id" }, current.created_by)),
                    React.createElement(Box_1.default, null,
                        React.createElement(Typography_1.default, { className: "card-header__label" }, "Created Date Time"),
                        React.createElement(Typography_1.default, { className: "card-header__id" }, formatDate(current.created_date_time)))),
                React.createElement(Box_1.default, { className: "card-content" }, sections.map(function (sectionKey) {
                    var sectionConstants = approvals_helper_1.feDetailLabels[sectionKey];
                    var currentSectionData = current[sectionKey];
                    var previousSectionData = previous === null || previous === void 0 ? void 0 : previous[sectionKey];
                    return (React.createElement(Box_1.default, { key: sectionKey },
                        React.createElement(Box_1.default, { className: "section__title-row" },
                            React.createElement(Box_1.default, { className: "section__accent-bar" }),
                            React.createElement(Typography_1.default, { variant: "h6", className: "section__title" }, formatSectionName(sectionKey)),
                            React.createElement(Box_1.default, { className: "section__divider" })),
                        React.createElement(Box_1.default, { className: "comparison-header" },
                            React.createElement(Box_1.default, { className: "comparison-header__field-col" }),
                            React.createElement(Box_1.default, { className: "comparison-header__col comparison-header__col--previous" },
                                React.createElement(Box_1.default, { className: "comparison-header__dot comparison-header__dot--previous" }),
                                React.createElement(Typography_1.default, { className: "comparison-header__label" }, "Previous")),
                            React.createElement(Box_1.default, { className: "comparison-header__col comparison-header__col--updated" },
                                React.createElement(Box_1.default, { className: "comparison-header__dot comparison-header__dot--updated" }),
                                React.createElement(Typography_1.default, { className: "comparison-header__label" }, "Updated"))),
                        React.createElement(Grid_1.default, { container: true, className: "fields-grid" }, Object.keys(currentSectionData)
                            .filter(function (fieldKey) { return sectionConstants[fieldKey]; })
                            .map(function (fieldKey) {
                            var fieldConfig = sectionConstants[fieldKey];
                            var currentRaw = currentSectionData[fieldKey];
                            var previousRaw = previousSectionData === null || previousSectionData === void 0 ? void 0 : previousSectionData[fieldKey];
                            var currentDisplay = formatValue(currentRaw, fieldConfig.type);
                            var previousDisplay = formatValue(previousRaw, fieldConfig.type);
                            var isCurrentNull = currentRaw === null || currentRaw === undefined;
                            var isPreviousNull = previousRaw === null || previousRaw === undefined;
                            var isDocument = ["doc", "document", "photo"].some(function (word) {
                                return fieldKey.includes(word);
                            });
                            var currentDoc = currentDocuments[fieldKey];
                            var previousDoc = previousDocuments[fieldKey];
                            return (React.createElement(Grid_1.default, { item: true, key: fieldKey, className: "fields-grid__row" },
                                React.createElement(Paper_1.default, { className: "field-card", elevation: 0 },
                                    React.createElement(Typography_1.default, { component: "span", className: "field-card__label" }, fieldConfig.label),
                                    React.createElement(Box_1.default, { className: "field-card__comparison" },
                                        React.createElement(Box_1.default, { className: "field-card__col field-card__col--previous" }, !isDocument ? (React.createElement(Typography_1.default, { className: "field-card__value ".concat(isPreviousNull
                                                ? "field-card__value--empty"
                                                : "field-card__value--filled") }, previousDisplay)) : previousDoc ? (React.createElement(React.Fragment, null,
                                            React.createElement(Box_1.default, { className: "download-btn" },
                                                React.createElement("img", { src: previousDoc.imageUrl, alt: "", style: { height: "60px", width: "60px" } }),
                                                React.createElement("a", { className: "icon-Vector", target: "_blank", href: previousDoc.uploadedUrl, download: true, style: { color: "#858585" } })),
                                            React.createElement(Box_1.default, { className: "image-title" }, previousDoc.documentName))) : isPreviousNull ? (React.createElement(Typography_1.default, { className: "field-card__value field-card__value--empty" }, "\u2014")) : (React.createElement(Typography_1.default, { className: "field-card__value field-card__value--empty" }, "Loading..."))),
                                        React.createElement(Box_1.default, { className: "field-card__col-divider" }),
                                        React.createElement(Box_1.default, { className: "field-card__col field-card__col--updated" }, !isDocument ? (React.createElement(Typography_1.default, { className: "field-card__value ".concat(isCurrentNull
                                                ? "field-card__value--empty"
                                                : "field-card__value--filled") }, currentDisplay)) : currentDoc ? (React.createElement(React.Fragment, null,
                                            React.createElement(Box_1.default, { className: "download-btn" },
                                                React.createElement("img", { src: currentDoc.imageUrl, alt: "", style: { height: "60px", width: "60px" } }),
                                                React.createElement("a", { className: "icon-Vector", target: "_blank", href: currentDoc.uploadedUrl, download: true, style: { color: "#858585" } })),
                                            React.createElement(Box_1.default, { className: "image-title" }, currentDoc.documentName))) : isCurrentNull ? (React.createElement(Typography_1.default, { className: "field-card__value field-card__value--empty" }, "\u2014")) : (React.createElement(Typography_1.default, { className: "field-card__value field-card__value--empty" }, "Loading...")))))));
                        }))));
                }))))));
}
exports.default = ApprovalsDisplay;
